export default __webpack_public_path__ + "static/media/dot_loader_white.b1d3cffd.gif";